import { Avatar, Button, ListItem, ListItemAvatar, ListItemText, Tooltip, Chip, Typography, Stack } from "@mui/material";
import HubIcon from '@mui/icons-material/Hub';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import React, { memo } from 'react';
import NodeCanvasLogo from '../../../assets/NodeCanvasLogo.svg';
import { Box } from "@mui/material/node";

const MyProjectItem = memo(({ project }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const handleClick = () => {
        navigate(`/project/${project.id}`);
    };

    return (
		<ListItem
            key={project.id}
            disableGutters
			sx={{
				borderRadius: 5,
				px: 2,
				py: 3,
				mb: 1,
				borderColor: theme.palette.divider,
				backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[50],
			}}
            secondaryAction={
                // The button is not affected by right padding, and that's all right.
                <Button 
                    variant="contained" 
                    onClick={handleClick} 
                    sx={{mr: 1,
                        backgroundColor: theme.palette.mainColor.main 
                    }}
                >
                    Open
                </Button>
            }
        >
            <ListItemAvatar sx={{ minWidth: 0, mr: 2 }}>
                <Avatar 
                    alt="Project" 
                    sx={{ 
                        width: 50, 
                        height: 50, 
                        bgcolor: "#fff" // Make avatar white
                    }} 
                >
                    <img
                        src={NodeCanvasLogo}
                        alt="NodeCanvas"
                        loading="lazy"
                        style={{
                            height: "32px",
                        }}
                    />
                    {/* <HubIcon sx={{ fontSize: 30 }} /> */}
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={
                    <Typography
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            minWidth: 0,
                            flexShrink: 1,
                            fontWeight: 500,
                            display: 'block',
                            marginBottom: 0.5
                        }}
                    >
                        {project.name}
                    </Typography>
                }
                secondary={
                    <Box>
                        <Typography variant="body2" color="text.secondary" sx={{ display: "block" }}>
                            {project.description.slice(0, 300)}
                        </Typography>
                        <Stack direction="row" spacing={1} sx={{ mt: 1, alignItems: 'center', flexWrap: 'wrap', minWidth: 0 }}>
                            {project.ispublic && (
                                <Tooltip title="The project is accessible through a public address">
                                    <Chip label="Public" color="primary" size="small" variant="outlined" />
                                </Tooltip>
                            )}
                            {project.ispublic === false && (
                                <Chip label="Private" color="primary" size="small" variant="outlined" />
                            )}
                            {project.allowcomments && (
                                <Tooltip title="Visitors can leave comments">
                                    <Chip label="Comments Enabled" color="primary" size="small" variant="outlined" />
                                </Tooltip>
                            )}
                        </Stack>
                    </Box>
                }
                sx={{marginRight: 8 }}
            />
        </ListItem>
    );
});

export { MyProjectItem };